module.exports = {
  "calendar": "Kalendar",
  "day": "dan",
  "dayPeriod": "AM/PM",
  "endDate": "Datum zavr\u0161etka",
  "era": "era",
  "hour": "sat",
  "minute": "minuta",
  "month": "mjesec",
  "second": "sekunda",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Odabrani datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Odabrani raspon: ".concat(args.startDate, " do ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Odabrano vrijeme: ".concat(args.time);
  },
  "startDate": "Datum po\u010Detka",
  "timeZoneName": "vremenska zona",
  "weekday": "dan u tjednu",
  "year": "godina"
};